import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["translations"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { LoadingSpinnerIcon } from "./icons.js";
export function createChatMessageLoaderComponent(_ref) {
  var createElement = _ref.createElement;
  return function ChatMessageLoader(userProps) {
    var userTranslations = userProps.translations,
      props = _objectWithoutProperties(userProps, _excluded);
    var translations = _objectSpread({
      loaderText: 'Thinking...'
    }, userTranslations);
    return createElement("article", _extends({
      className: "ais-ChatMessageLoader ais-ChatMessage ais-ChatMessage--left ais-ChatMessage--subtle"
    }, props), createElement("div", {
      className: "ais-ChatMessage-container"
    }, createElement("div", {
      className: "ais-ChatMessage-leading"
    }, createElement("div", {
      className: "ais-ChatMessageLoader-spinner"
    }, createElement(LoadingSpinnerIcon, {
      createElement: createElement
    }))), createElement("div", {
      className: "ais-ChatMessage-content"
    }, createElement("div", {
      className: "ais-ChatMessage-message"
    }, translations.loaderText && createElement("div", {
      className: "ais-ChatMessageLoader-text"
    }, translations.loaderText), createElement("div", {
      className: "ais-ChatMessageLoader-skeletonWrapper"
    }, createElement("div", {
      className: "ais-ChatMessageLoader-skeletonItem"
    }), createElement("div", {
      className: "ais-ChatMessageLoader-skeletonItem"
    }))))));
  };
}